module.exports = __webpack_public_path__ + "img/bg.3c88e0ab.png";